export default class UnloadGuidePerformance {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.guidePerformances.set([]);
  }
}
